import { EntityState, createEntityAdapter } from '@ngrx/entity';
import { CrimpCloudPartnerActions, CrimpCloudPartnerActionTypes } from './crimp-cloud-partners.actions';
import { CrimpCloudPartnerResponse } from '@ct-asm/asm-asset-management-typescript-sdk/dist/src/crimp-cloud-partners/crimp_cloud_partners_response';
import { serviceError } from 'src/app/shared/models/serviceError';

export interface CrimpCloudPartnerState extends EntityState<CrimpCloudPartnerResponse> {
  partnerListedSuccess: boolean;
  partnerListingFailed: boolean;
  partnerCreatedSuccess: boolean;
  partnerCreatedFailed: serviceError | null;
  partnerDeletedSuccess: boolean;
  partnerDeletedFailed: serviceError | null;
  error: any;
  crimpCloudPartnerList: CrimpCloudPartnerResponse[];
  loggedInPartnerCompanyList: CrimpCloudPartnerResponse[];
  loggedInPartnerCompanyListedSuccess: boolean;
  loggedInPartnerCompanyListedFailed: boolean;
  totalRecords: number;
}

export const CrimpCloudPartnerAdapter = createEntityAdapter<CrimpCloudPartnerResponse>({
  selectId: (e) => e.uniqueId,
});

export const initialState: CrimpCloudPartnerState = CrimpCloudPartnerAdapter.getInitialState({
  partnerListedSuccess: false,
  partnerListingFailed: false,
  partnerCreatedSuccess: false,
  partnerCreatedFailed: null,
  partnerDeletedSuccess: false,
  partnerDeletedFailed: null,
  error: null,
  crimpCloudPartnerList: [],
  loggedInPartnerCompanyList: [],
  loggedInPartnerCompanyListedSuccess: false,
  loggedInPartnerCompanyListedFailed: false,
  totalRecords: 0,
});

export function CrimpCloudPartnerReducer(
  state = initialState,
  action: CrimpCloudPartnerActions
): CrimpCloudPartnerState {
  switch (action.type) {
    case CrimpCloudPartnerActionTypes.LIST_CRIMP_CLOUD_PARTNERS: {
      return {
        ...state,
        partnerListedSuccess: false,
        partnerListingFailed: false,
        crimpCloudPartnerList: [],
        totalRecords: 0
      };
    }

    case CrimpCloudPartnerActionTypes.LIST_CRIMP_CLOUD_PARTNERS_SUCCESS: {
      return {
        ...state,
        crimpCloudPartnerList: action.payload.data,
        totalRecords: action.payload.data.length,
        partnerListedSuccess: true,
      };
    }

    case CrimpCloudPartnerActionTypes.LIST_CRIMP_CLOUD_PARTNERS_FAILED: {
      return {
        ...state,
        partnerListingFailed: true,
        crimpCloudPartnerList: [],
        totalRecords: 0
      };
    }

    case CrimpCloudPartnerActionTypes.LIST_LOGGED_IN_PARTNER_COMPANY: {
      return {
        ...state,
        loggedInPartnerCompanyListedSuccess: false,
        loggedInPartnerCompanyListedFailed: false,
        loggedInPartnerCompanyList: []
      };
    }

    case CrimpCloudPartnerActionTypes.LIST_LOGGED_IN_PARTNER_COMPANY_SUCCESS: {
      return {
        ...state,
        loggedInPartnerCompanyListedSuccess: true,
        loggedInPartnerCompanyList: action.payload.data,
      };
    }


    case CrimpCloudPartnerActionTypes.LIST_LOGGED_IN_PARTNER_COMPANY_FAILED: {
      return {
        ...state,
        loggedInPartnerCompanyListedFailed: true,
        loggedInPartnerCompanyList: []
      };
    }

    case CrimpCloudPartnerActionTypes.CREATE_CRIMP_CLOUD_PARTNERS: {
      return {
        ...state,
        partnerCreatedSuccess: false,
        partnerCreatedFailed: null,
      };
    }

    case CrimpCloudPartnerActionTypes.CREATE_CRIMP_CLOUD_PARTNERS_SUCCESS: {
      return {
        ...state,
        crimpCloudPartnerList: [...state.crimpCloudPartnerList, ...action.payload],
        totalRecords: state.totalRecords + action.payload.length,
        partnerCreatedSuccess: true,
      };
    }

    case CrimpCloudPartnerActionTypes.CREATE_CRIMP_CLOUD_PARTNERS_FAILED: {
      return {
        ...state,
        ...{ partnerCreatedFailed: action.payload },
      };
    }

    case CrimpCloudPartnerActionTypes.DELETE_CRIMP_CLOUD_PARTNERS: {
      return {
        ...state,
        partnerDeletedSuccess: false,
        partnerDeletedFailed: null
      };
    }

    case CrimpCloudPartnerActionTypes.DELETE_CRIMP_CLOUD_PARTNERS_SUCCESS: {
      return {
        ...state,
        partnerDeletedSuccess: true,
        crimpCloudPartnerList: state.crimpCloudPartnerList.filter(p => p.crimpcloudPartnerId !== action.payload),
      };
    }

    case CrimpCloudPartnerActionTypes.DELETE_CRIMP_CLOUD_PARTNERS_FAILED: {
      return {
        ...state,
        ...{ partnerDeletedFailed: action.payload }
      };
    }

    case CrimpCloudPartnerActionTypes.RESET_CRIMP_CLOUD_PARTNERS:
      return {
        ...state,
        ...{
          partnerListedSuccess: false,
          partnerListingFailed: false,
        },
      };

    case CrimpCloudPartnerActionTypes.RESET_PARTNER_CREATION_FLAGS:
      return {
        ...state,
        ...{
          partnerCreatedFailed: null,
          partnerCreatedSuccess: false,
        },
      };

    case CrimpCloudPartnerActionTypes.RESET_PARTNER_DELETION_FLAGS:
      return {
        ...state,
        ...{
          partnerDeletedFailed: null,
          partnerDeletedSuccess: false
        },
      };

    case CrimpCloudPartnerActionTypes.RESET_CRIMP_CLOUD_PARTNER_LIST:
      return {
        ...state,
        crimpCloudPartnerList: [],
        totalRecords: 0
      };

    default:
      return state;
  }
}
